import { openModal } from "action/modal/openModal";
import GarageDropdown from "component/garage-dropdown/garage-dropdown.component";
import InputGroup from "component/react-bootstrap/InputGroup";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import { useDispatch, useSelector } from "react-redux";
import { createVehicleDescription } from "util/vehicle/createVehicleDescription";

function GarageDropdownWrapper(props) {
  const {
    loc, dropdownMenuClass, applyGarageDropdownClass, callBack, darkIcon = false,
  } = props;
  const selectedVehicle = useSelector((state: RootState) => state.garage.selectedVehicle);
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  let vehicleDescription = t("ALL VEHICLES");
  if (selectedVehicle) {
    vehicleDescription = createVehicleDescription(selectedVehicle);
  }

  function openVehicleSelectorModal() {
    dispatch(openModal("vehicleSelector", { forceTrigger: true, addNewVehicle: true }));
  }

  return (
    <GarageDropdown
      dropdownComponentClass={InputGroup.Button}
      dropdownId="dropdown-header-garage"
      buttonText={vehicleDescription}
      onAddVehicleClick={openVehicleSelectorModal}
      loc={loc}
      dropdownMenuClass={dropdownMenuClass}
      applyGarageDropdownClass={applyGarageDropdownClass}
      callBack={callBack}
      darkIcon={darkIcon}
    />
  );
}

export default GarageDropdownWrapper;
